import type { FaireProductEntity } from "../../entity_types/product";

export const p_t3avksrwvm: FaireProductEntity = {
  token: "p_t3avksrwvm",
  type: "product",
  name: "Mike & Ike Tropical Typhoon 0.78oz 24 packs",
  brandToken: "b_8343je4q5y",
  brandName: "Snacky Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/82105b5540e0e3ef381a1bc48dbd38407b317db7e3fee58f2811b4a27896dcae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb3e50e3a083090597a4ea32b2165db6fe4b152e5a1e2283571c2ef66cc45d73.jpeg",
    "https://cdn.faire.com/fastly/e3b88caf8f5e654b36b5d5f784fe50e9ff1a5de4566da1c50d5f727e13ae74f3.jpeg",
    "https://cdn.faire.com/fastly/99de1d6d5121c853b11e74376beb6a65021a12d798529fe746ff23bd39f2e90e.jpeg",
    "https://cdn.faire.com/fastly/4e9d584355190c7f7508bee00d1a17e55e14ef806141c2c6bcd8952825def366.jpeg",
    "https://cdn.faire.com/fastly/35a7836bc5dd7f37af856448f76a1d0d63065e2f1c83813b58dcf8c2acc9690c.jpeg",
  ],
  priceDollars: 0.39,
  description:
    "**Mike & Ike Tropical Typhoon Chewy Candy — 0.78 oz Theater Boxes (24 Count)**\n\nTake your taste buds on a tropical adventure with Mike & Ike Tropical Typhoon! Bursting with exotic fruit flavors like Paradise Punch, Kiwi-Banana, Caribbean Punch, Strawberry-Banana, and Mango, these chewy candies deliver a wave of fruity fun in every bite. Each 0.78 oz theater-style box is perfectly sized for snacking, sharing, or packing in lunchboxes.\n\n**Product Details:**\n\n* Flavors: Paradise Punch, Kiwi-Banana, Caribbean Punch, Strawberry-Banana, Mango\n* Format: Chewy fruit-flavored candy\n* Box Size: 0.78 oz each\n* Pack Size: 24 boxes per case\n* Shelf Life: 12 months when stored in a cool, dry place\n\n**Why Customers Love It:**\n\n* Variety of delicious tropical fruit flavors\n* Fun, chewy texture everyone enjoys\n* Convenient theater-style mini boxes\n* Gluten-free and fat-free treat\n* From Mike & Ike, a brand known for fruity candy favorites\n\n**Case Dimensions & Weight:**\n\n* Case includes 24 mini theater boxes\n* Approx. case weight: 1.2 lbs (0.54 kg)\n\n**Allergen Information:**\nGluten-free and fat-free. Contains corn syrup. Produced in a facility that also processes wheat and soy.\n\nMike & Ike Tropical Typhoon is a fruity escape packed into every bite, making it a must-have for retail shelves, concessions, and candy gift assortments.\n",
  tags: [],
  msrpDollars: 0.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:59.247Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
